export default __webpack_public_path__ + "static/media/12-31-02-bowie.a007c7bc.m4a";